import { VrElementField } from '../../../shared/vr-element-field/vr-element-field';

export abstract class VrSlideToggle extends VrElementField { }
